// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fullscreen[data-v-1dca4761]{\n  width: 100%;\n  height: 100vh;\n}\n", ""]);
// Exports
module.exports = exports;
